import { COUNTRY_SHORTCODES as Country } from '../../../constants'
// tslint:disable-next-line:max-line-length
import { BankAdditionalVerificationPages as Page } from '../../../typeModules/events'

// The flow will follow the steps sequentially
// as defined in the array
//
// The country key is defined by the
// country field on the application object of the Dasher

// United States
export const StepsUS: Page[] = [
  Page.VerifyIdentity,
  Page.VerifyAddress,
  Page.IdentificationNumber,
  Page.GovernmentId,
  Page.SubmitPhotoId,
  Page.VerificationInProgress,
  Page.VerificationComplete,
]

// Canada
export const StepsCA: Page[] = [
  Page.VerifyIdentity,
  Page.IdentificationNumber,
  Page.GovernmentId,
  Page.SubmitPhotoId,
  Page.VerificationInProgress,
  Page.VerificationComplete,
]

// Australia
export const StepsAU: Page[] = [
  Page.VerifyIdentity,
  Page.IdentificationNumber,
  Page.GovernmentId,
  Page.SubmitPhotoId,
  Page.SubmitPhotoIdBack,
  Page.VerificationInProgress,
  Page.VerificationComplete,
]

export const Steps = {
  [Country.US]: StepsUS,
  [Country.CA]: StepsCA,
  [Country.AU]: StepsAU,
}
